import React from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css';


class TaxSavingType extends React.Component {
    constructor() {
        super();
        this.state = {
            item: [],
            taxSavingType: ''
        }
    }

    selectTaxSavingTypeRow = (selectTaxSavingType) => {
        this.setState({ taxSavingType: selectTaxSavingType })
        this.props.rowSelectionTaxSavingType(selectTaxSavingType)
    }

    render() {
        const data = this.props.adminData.taxSavingType;
        const columns = [
            {
                Header: "Saving Type",
                accessor: "TaxSavingTypeName",
                className: "header-class",
                width: 250
            },

            {
                Header: "Tax Category",
                accessor: "TaxCategoryCode",
                className: "header-class",
                width: 200
            }
        ]
        return (
            <>
                <div className="row">
                    <div className="container-fluid">
                        <ReactTable className="-highlight IRTable"
                            columns={columns}
                            data={data}
                            showPagination={false}
                            pageSize={data.length}
                            getTrProps={(state, rowInfo, column, instance) => {
                                return {
                                    onClick: () => {
                                        this.selectTaxSavingTypeRow(rowInfo.original.TaxSavingType)
                                    },
                                    style: {
                                        backgroundColor: this.props.TaxSavingType === '' ? '' : (this.state.taxSavingType === rowInfo.original.TaxSavingType) ? '#ffefbb' : ''
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </>
        )
    }
}
export default TaxSavingType